import { Injectable } from '@angular/core';

export enum FileContentTypeOptions {
	PDF = 'application/pdf',
	PNG = 'image/png',
	JPEG = 'image/jpeg',
	ZIP = 'application/zip',
	CSV = 'text/csv',
	JSON = 'application/json'
}

export type FileContentType = `${FileContentTypeOptions}`;

const contentTypeExtensionMap: Record<FileContentTypeOptions, string> = {
	[FileContentTypeOptions.PDF]: 'pdf',
	[FileContentTypeOptions.PNG]: 'png',
	[FileContentTypeOptions.JPEG]: 'jpg',
	[FileContentTypeOptions.ZIP]: 'zip',
	[FileContentTypeOptions.CSV]: 'csv',
	[FileContentTypeOptions.JSON]: 'json'
};

@Injectable()
export class DownloadService {
	async downloadFileFromBase64(
		name: string,
		base64: string,
		contentType: FileContentType = FileContentTypeOptions.PDF
	): Promise<void> {
		const byteCharacters = atob(base64);
		const byteNumbers = new Array(byteCharacters.length)
			.fill(0)
			.map((_, i) => byteCharacters.charCodeAt(i));
		const byteArray = new Uint8Array(byteNumbers);

		const blob = new Blob([byteArray], { type: contentType });
		const url = window.URL.createObjectURL(blob);

		const extension = contentTypeExtensionMap[contentType] ?? 'txt';

		const a = document.createElement('a');
		a.href = url;
		a.download = `${name}.${extension}`;
		document.body.appendChild(a);
		a.click();
		document.body.removeChild(a);

		window.URL.revokeObjectURL(url);
	}

	async downloadFileFromBlob(name: string, blob: Blob): Promise<void> {
		const url = window.URL.createObjectURL(blob);

		const a = document.createElement('a');
		a.href = url;
		a.download = name;
		document.body.appendChild(a);
		a.click();
		document.body.removeChild(a);

		window.URL.revokeObjectURL(url);
	}
}
